(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('type-remisecommerciale', {
            parent: 'entity',
            url: '/type-remisecommerciale?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.typeRemisecommerciale.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-remisecommerciale/type-remisecommerciales.html',
                    controller: 'TypeRemisecommercialeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeRemisecommerciale');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-remisecommerciale-detail', {
            parent: 'entity',
            url: '/type-remisecommerciale/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.typeRemisecommerciale.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-remisecommerciale/type-remisecommerciale-detail.html',
                    controller: 'TypeRemisecommercialeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeRemisecommerciale');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TypeRemisecommerciale', function($stateParams, TypeRemisecommerciale) {
                    return TypeRemisecommerciale.get({id : $stateParams.id});
                }]
            }
        })
        .state('type-remisecommerciale.new', {
            parent: 'type-remisecommerciale',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-remisecommerciale/type-remisecommerciale-dialog.html',
                    controller: 'TypeRemisecommercialeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-remisecommerciale', null, { reload: true });
                }, function() {
                    $state.go('type-remisecommerciale');
                });
            }]
        })
        .state('type-remisecommerciale.edit', {
            parent: 'type-remisecommerciale',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-remisecommerciale/type-remisecommerciale-dialog.html',
                    controller: 'TypeRemisecommercialeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeRemisecommerciale', function(TypeRemisecommerciale) {
                            return TypeRemisecommerciale.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-remisecommerciale', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-remisecommerciale.delete', {
            parent: 'type-remisecommerciale',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-remisecommerciale/type-remisecommerciale-delete-dialog.html',
                    controller: 'TypeRemisecommercialeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeRemisecommerciale', function(TypeRemisecommerciale) {
                            return TypeRemisecommerciale.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-remisecommerciale', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
